import './styles.scss';

export const InfoBadge = ({ info, bold = true }) => {
  return <div className="info_badge__container" style={!bold ? { fontWeight: 400 } : {}}>
    {info}
  </div>
}
